<div class="d-flex gap-3 flex-fill cursor-pointer">
  <div class="d-flex flex-column align-items-start justify-content-between w-100">
    <div class="d-flex align-items-center flex-wrap gap-1 mb-1">
      <h5 class="fw-semibold mb-0 text-dark me-2">{{ product().productCode }}</h5>
      <span class="d-flex flex-nowrap gap-2">
        @if (product().productClassName) {
          <span class="badge border fw-500 text-body-secondary fw-500 text-dark border-dark-subtle">
            {{ product().productClassName }}
          </span>
        }

        @if (product().productTypeName) {
          <span class="badge border fw-500 text-body-secondary fw-500 text-dark border-dark-subtle">
            {{ product().productTypeName }}
          </span>
        }

        @if (product().isCancelled) {
          <span class="badge border fw-500 fw-500 text-danger border-danger-subtle"> Cancelled </span>
        }

        @if (isLocked()) {
          <span class="badge bg-secondary-subtle text-secondary-emphasis fw-500 d-inline-flex align-items-center gap-1">
            <i class="bi bi-lock-fill"></i>
            Locked
          </span>
        }
      </span>
    </div>
    @if (product().locationCode && product().locationName) {
      <p class="mb-0 text-muted fw-400">{{ product().locationCode }}/{{ product().locationName }}</p>
    }
    <div class="d-flex flex-wrap align-items-center gap-1 gap-xl1-3 fs-14 fw-400">
      @if (product().lineNumber) {
        <span class="text-muted"
          >Line: <span class="fw-500 text-black">{{ product().lineNumber }}</span></span
        >
      }
      <span class="text-muted"
        >Qty: <span class="fw-500 text-black">{{ product().quantity }}</span></span
      >
      <span class="text-muted">
        Unit Price: <span class="fw-500 text-black">{{ product().unitPrice | currencyFormat }}</span>
      </span>

      <!-- <span class="text-muted"
                      >Amount: <span class="fw-500 text-black">{{ option.amount | currencyFormat }}</span></span
                    >
                    <span class="text-muted"
                      >Total: <span class="fw-500 text-black">{{ option.total | currencyFormat }}</span></span
                    > -->
    </div>
  </div>
</div>

@if (!isKitLinkedProduct() && (canCancel() || canDelete())) {
  <div ngbDropdown container="body" class="d-inline-flex" (click)="$event.stopPropagation()">
    <span
      class="align-items-center d-flex justify-content-center p-1 rounded-2 cursor-pointer"
      ngbDropdownToggle
      role="button"
    >
      <svg-icon [name]="'menu-dots'" class="svg-24"></svg-icon>
    </span>
    <div ngbDropdownMenu>
      @if (canCancel()) {
        <button ngbDropdownItem (click)="showConfirmation($event, 'cancel')">Cancel Product</button>
      }
      @if (canDelete()) {
        <button ngbDropdownItem class="text-danger" (click)="showConfirmation($event, 'delete')">Delete</button>
      }
    </div>
  </div>
}

<p-confirmdialog />
